import { render, staticRenderFns } from "./ProductsOverLimitModal.vue?vue&type=template&id=184e6e7b"
import script from "./ProductsOverLimitModal.vue?vue&type=script&lang=js"
export * from "./ProductsOverLimitModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports